import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from '@redux-devtools/extension';

import rootReducer from './reducers/root.reducer';

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['context', 'auth', 'events', 'clients'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const configureStore = () => {
	const middleware = [thunk];
	if (import.meta.env.MODE !== 'production') {
		middleware.push(createLogger({ collapsed: true }));
	}
	const store = createStore(
		persistedReducer,
		undefined,
		composeWithDevTools(applyMiddleware(...middleware))
	);
	const persistor = persistStore(store);
	return { store, persistor };
};

export const { store, persistor } = configureStore();
